import Content from '../../content.js';

namespace('IO.Views.Servers', function (exports) {
  'use strict';

  var DynamicGroupForm = IO.Views.Components.DynamicGroupForm,
    New = Content.extend({
      dom: {
        HOSTNAME: '#server_hostname',
        CLIENT_CODE: '#client-code',
        SERVER_FORM: '.server-form',
        SELECT2_FIELD: '.select2select',
        PUPPET_PROFILES: '#server_puppet_profiles',
        CURRENT_HOSTNAME_FORM: '#server_hostname',
      },

      events: function () {
        var events = {};

        events['submit ' + this.dom.SERVER_FORM] = '_beforeSave';
        return events;
      },

      /*
        PUBLIC FUNCTIONS
      */
      afterRender: function () {
        this.listenTo(this.dynamicForm, 'after:filter', this.checkRadioButtons);
        this.$(this.dom.SELECT2_FIELD).select2();
      },

      onDestroy: function () {
        this.dynamicForm.remove();
      },

      render: function () {
        this.puppetProfilesOrder = new PuppetProfilesOrder(this.$el);
        this.dynamicForm = new DynamicGroupForm({
          el: this.$el,
          formTarget: this.dom.SERVER_FORM,
          radio: true,
        });
        this.dynamicForm.render();
        this.checkRadioButtons();
        this._autoFillAndFocusHostName();

        PropertyTypeMask.applyMasks.call(this);
        this.selectedPuppetModules = this._getSelectedPuppetModules();
      },

      _beforeSave: function (e) {
        if (!$(this.dom.SERVER_FORM).hasClass('puppet-module-changes-yes')) {
          this._checkPuppetModuleChanges();
          e.preventDefault();
          return false;
        }

        return true;
      },

      /*
        PRIVATE FUNCTIONS
      */
      _autoFillAndFocusHostName: function () {
        var element = $(this.dom.HOSTNAME),
          value = $(this.dom.CLIENT_CODE).val();

        element.val(value);
        element.trigger('focus');
      },

      _checkPuppetModuleChanges: function () {
        var self = this,
          proceed,
          newPuppetModules,
          addedModules,
          removedModules,
          puppetModuleChangesModal,
          hostname;

        proceed = function (shouldProceed) {
          if (shouldProceed) {
            $(self.dom.SERVER_FORM).addClass('puppet-module-changes-yes');
            $(self.dom.SERVER_FORM).submit();
          } else {
            $(self.dom.SERVER_FORM).addClass('puppet-module-changes-no');
          }
        };

        newPuppetModules = this._getSelectedPuppetModules();

        if (
          $(this.selectedPuppetModules).not(newPuppetModules).length === 0 &&
          $(newPuppetModules).not(this.selectedPuppetModules).length === 0
        ) {
          proceed(true);
          return;
        }

        addedModules = $(newPuppetModules)
          .not(this.selectedPuppetModules)
          .get();
        removedModules = $(this.selectedPuppetModules)
          .not(newPuppetModules)
          .get();
        hostname = $(this.dom.CURRENT_HOSTNAME_FORM).val();

        puppetModuleChangesModal = new IO.Views.NodeGroups.PuppetModuleChanges({
          wait: true,
        });
        puppetModuleChangesModal.setModuleChanges(
          hostname,
          addedModules,
          removedModules,
        );
        puppetModuleChangesModal.answer(function (shouldProceed) {
          proceed(shouldProceed);
          puppetModuleChangesModal.destroy();
        });
      },

      _getSelectedPuppetModules: function () {
        return $(this.dom.PUPPET_PROFILES + ' option:selected')
          .map(function () {
            return $(this).text();
          })
          .get();
      },
    });

  exports.New = New;
});
